import styled, {keyframes} from 'styled-components'
import sx from '@fuegokit/react/sx'

export const SVG = styled.svg`
  fill: ${p => (p.color ? p.color : 'inherit')};
  ${sx}
`
export const StopOne = styled.stop`
  stop-color: var(--stopColor1);
`
export const StopTwo = styled.stop`
  stop-color: var(--stopColor2);
`

export const Wrapper = styled.div``

export const markLine = keyframes`
  0%,
  100% {
    stroke-dasharray: 500;
    stroke-dashoffset: -850;
  }
  50% {
    stroke-dasharray: 500;
    stroke-dashoffset: -450;
  }
`
export const markColors = keyframes`
  0%,
  100% {
    stroke: #f96c2c;
  }
  33% {
    stroke: #e54074;
  }
  66% {
    stroke: #a044b9;
  }
`

export const HiddenSVG = styled.svg`
  visibility: hidden;
  position: absolute;
  left: -9999px;
  overflow: hidden;
`
export const MarkForeground = styled.path`
  stroke-dasharray: 500;
  stroke-dashoffset: -850;
  /* &:hover {
    animation-name: markLine;
    animation-duration: 1s;
    animation-fill-mode: forwards;
  } */
`
export const MarkBackground = styled.path`
  /* &:hover {
    animation-name: markColors;
    animation-duration: 1s;
    animation-fill-mode: forwards;
  } */
`
export const AnimatedSVG = styled.svg`
  &:hover {
    cursor: pointer;
    ${MarkBackground} {
      animation-name: ${markColors};
      animation-duration: 1s;
      animation-fill-mode: forwards;
    }
    ${MarkForeground} {
      animation-name: ${markLine};
      animation-duration: 1s;
      animation-fill-mode: forwards;
    }
  }
`
